<template>
    <div class="messenger-loader" :style="'height: ' + height + ';width: ' + width + ';'">
        <svg version="1.1" class="loader-center" viewBox="0 0 180 180" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <path
                d="M78.1,164.1l8,-15.9c-27.1,-1.8 -49,-22.1 -53.4,-48.4l-16.5,-8.4l-15.3,7.8c4.2,43.8 40.4,78.6 85,80.6l-7.8,-15.7Zm23.9,-147.7l-7.9,15.9c27,1.8 48.9,22.1 53.3,48.4l16.5,8.3l15.4,-7.7c-4.2,-43.8 -40.4,-78.7 -85,-80.7l7.7,15.8Zm61.9,85.8l-15.9,-8c-1.8,27.1 -22.1,49 -48.4,53.4l-8.3,16.5l7.7,15.3c43.8,-4.1 78.7,-40.4 80.7,-85l-15.8,7.8Zm-163.4,-16.1c2,-44.6 36.8,-80.9 80.8,-85.1l7.8,15.4l-8.4,16.5c-26.3,4.4 -46.8,26.3 -48.6,53.4l-15.9,-8l-15.7,7.8Z"
                fill="#CE0F2D"
                stroke="none"
            ></path>
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        height: {
            default: '50px',
        },
        width: {
            default: '50px',
        },
    },
};
</script>

<style>
@-webkit-keyframes rotate-scale-up {
    0% {
        -webkit-backface-visibility: hidden;
        -webkit-transform: scale(1) rotateZ(0);
        transform: scale(1) rotateZ(0);
    }
    50% {
        -webkit-backface-visibility: hidden;
        -webkit-transform: scale(1.5) rotateZ(180deg);
        transform: scale(1.5) rotateZ(180deg);
    }
    100% {
        -webkit-backface-visibility: hidden;
        -webkit-transform: scale(1) rotateZ(360deg);
        transform: scale(1) rotateZ(360deg);
    }
}

@keyframes rotate-scale-up {
    0% {
        -webkit-backface-visibility: hidden;
        -webkit-transform: scale(1) rotateZ(0);
        transform: scale(1) rotateZ(0);
    }
    50% {
        -webkit-backface-visibility: hidden;
        -webkit-transform: scale(1.5) rotateZ(180deg);
        transform: scale(1.5) rotateZ(180deg);
    }
    100% {
        -webkit-backface-visibility: hidden;
        -webkit-transform: scale(1) rotateZ(360deg);
        transform: scale(1) rotateZ(360deg);
    }
}

.messenger-loader {
    max-width: 100%;
    max-height: 100%;
}

.messenger-loader .loader-center {
    -webkit-animation: rotate-scale-up 1s ease-in-out infinite both;
    animation: rotate-scale-up 1s ease-in-out infinite both;
    width: 500px;
    height: auto;
    max-width: 100%;
}
</style>
